import { z } from 'zod';

export const workerSchema = z.object({
  email: z.string().email('Invalid email address').min(1, 'Email is required'),
  full_name: z.string().min(2, 'Full name must be at least 2 characters'),
  mobile_number: z.string()
    .min(10, 'Mobile number must be at least 10 digits')
    .regex(/^[0-9+\-\s()]*$/, 'Invalid mobile number format')
    .optional()
    .nullable(),
  department_id: z.string().uuid('Invalid department ID').optional().nullable(),
  status: z.enum(['active', 'pending', 'inactive']),
  role: z.literal('worker')
});

export type WorkerFormData = z.infer<typeof workerSchema>;